import Card from './Card.view';

export default Card;
